import Map from "./Map";
import Help from "./Help";
import Share from "./Share";
import Like from "./Like";
import { lazy } from "react";
const Graph = lazy(() => import("./Graph"))
export { Share, Graph, Map, Help, Like };
